export default __webpack_public_path__ + "static/media/3849.78b2acb6.png";